export default {
  'prefer quality when buying clothes': 'preference',
  'prefer comfort when buying clothes': 'preference',
  'prefer style when buying clothes': 'preference',
  'prefer safety when buying automobiles': 'preference',
  'like romance movies': 'preference',
  'like science-fiction movies': 'preference',
  'like war movies': 'preference',
  'like adventure movies': 'preference',
  'like historical movies': 'preference',
  'like action movies': 'preference',
  'like documentary movies': 'preference',
  'like outdoor activities': 'preference',
  'like horror movies': 'preference',
  'like musical movies': 'preference',
  'like drama movies': 'preference',
  'like rock music': 'preference',
  'like classical music': 'preference',
  'like rap music': 'preference',
  'like R&B music': 'preference',
  'like hip hop music': 'preference',
  'like Latin music': 'preference',
  'like country music': 'preference',
  'read non-fiction books': 'preference',
  'read autobiographical books': 'preference',
  'read entertainment magazines': 'preference',
  'read financial investment books': 'preference',
  'to be sensitive to ownership cost when buying automobiles': 'behaviour',
  'be influenced by product utility when making product purchases': 'behaviour',
  'be influenced by online ads when making product purchases': 'behaviour',
  'be influenced by social media when making product purchases': 'behaviour',
  'be influenced by brand name when making product purchases': 'behaviour',
  'be influenced by family when making product purchases': 'behaviour',
  'prefer using credit cards for shopping': 'behaviour',
  'indulge in spur of the moment purchases': 'behaviour',
  'read often': 'behaviour',
  'eat out frequently': 'behaviour',
  'have a gym membership': 'behaviour',
  'be concerned about the environment': 'behaviour',
  'consider starting a business in next few years': 'behaviour',
  'have experience playing music': 'behaviour',
  'attend live musical events': 'behaviour',
  'volunteer for social causes': 'behaviour',
};
